import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  TopupTransactionsPage,
  TransactionAllPage,
  CustomerCreditTransactionsPage,
} from '../lazyPages';

export const TransactionAllRoutes = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('TRANSACTION_ALL')}>
            <TransactionAllPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="topup-transactions"
        element={
          <GuardedPageRoute
            pageName={t(
              'STAFF_SIDEBAR.TRANSACTION_ALL.CUSTOMER_TOPUP_TRANSACTIONS'
            )}
          >
            <TopupTransactionsPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="customer-credit-transactions"
        element={
          <GuardedPageRoute
            pageName={t(
              'STAFF_SIDEBAR.TRANSACTION_ALL.CUSTOMER_CREDIT_TRANSACTIONS'
            )}
          >
            <CustomerCreditTransactionsPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
